import { AuthErrorCodes } from 'firebase/auth';
import { reportError, sendEvent } from '@dash0/sdk-web';

const EXPECTED_SIGN_IN_CODES = new Set<string>([
  AuthErrorCodes.USER_DELETED,
  AuthErrorCodes.INVALID_PASSWORD,
  AuthErrorCodes.INVALID_EMAIL,
  'auth/invalid-login-credentials',
  'auth/invalid-credential',
]);

function getErrorCode(error: unknown): string {
  const code = (error as { code?: unknown })?.code;
  return typeof code === 'string' && code.length > 0 ? code : 'unknown';
}

export function isExpectedFirebaseSignInError(error: unknown): boolean {
  return EXPECTED_SIGN_IN_CODES.has(getErrorCode(error));
}

export function reportFirebaseSignInError(error: unknown, attributes: Record<string, string | boolean> = {}): void {
  const code = getErrorCode(error);
  if (code === AuthErrorCodes.MFA_REQUIRED) {
    return;
  }

  const expected = isExpectedFirebaseSignInError(error);
  const message = error instanceof Error ? error.message : 'Firebase sign-in failed';
  const attrs = {
    'auth.operation': 'signInWithEmailAndPassword',
    'firebase.auth.error.code': code,
    'auth.expected': expected,
    ...attributes,
  };

  try {
    if (expected) {
      sendEvent('auth.sign_in_rejected', {
        title: 'Firebase sign-in rejected (expected credentials error)',
        severity: 'WARN',
        attributes: attrs,
      });
      return;
    }

    reportError(
      {
        message,
        name: error instanceof Error ? error.name : 'FirebaseError',
        stack: error instanceof Error ? error.stack : undefined,
      },
      { attributes: attrs },
    );
  } catch {
    // Telemetry must not break login.
  }
}
